<template>
  <div id="signContract_warpper">
    <nav-bar titleText="电子合同" titleWeight="bold" @goBack="goBack"></nav-bar>
    <div class="stepper-warpper">
      <van-stepper v-model="value" input-width="40px" step="0.2" :decimal-length="1" :disabled="isDisabled"
        @change="stepperOnchange" />
      <div class="percent">{{percentValue}}</div>
    </div>
    <div class="contentBox">
      <div id="contidract" :style="contidractStyle" ref="contidract">
        <div :style="pdfStyle" ref="pdfbox">
          <pdf v-for="i in numPages" :key="i" :src="pdfSrc" :page="i" ref="pdfs" @loaded="pdfLoaded(i)"
            :style="{width: '100%'}">
          </pdf>
        </div>
      </div>
    </div>
    <div id="signBox">
      <!-- <div id="signNameCanvasBox" ref="signNameCanvasBox">
        <p ref="signature" class="signature" @click="goSigning">点击签名</p>
        <canvas class="canvas" ref="myCanvas" width="200" height="98">您的浏览器不支持 HTML5 canvas 标签。</canvas>
      </div> -->
      <div class="complete" v-if="entry == 1">
        <van-button @click="handleSignClick" type="primary" class="operation_btn" :disabled="!checkSign">确定</van-button>
      </div>
      <div class="complete" id="copycode" v-if="entry == 2" @click="copyLink()" :data-clipboard-text='copyContent'>
        <div class="copylink">
          <img class="copylinkImg" src="../../../assets/house/copylink.png" alt="">
          <div class="copylinkTxt">复制合同链接</div>
        </div>
      </div>
    </div>


    <van-dialog v-model="show" title="签署校验" confirmButtonColor="#F9591B" show-cancel-button @confirm="phoneConfirm">
      <div class="modal">
        <van-row class="user-links">
          <van-cell-group>
            <van-field class="mobile" v-model="phone" placeholder="请输入手机号" type="number"
              onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="12" />
            <van-field class="codeBox" v-model="msg" placeholder="请输入短信验证码"
              onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
              maxlength="6">
              <van-button slot="button" class="verification_code" size="small" @click="getvarify"
                v-if="downcounttime == 0">获取验证码</van-button>
              <van-button class="downcount" slot="button" size="small" v-if="downcounttime == 1">{{down}}s后获取
              </van-button>
            </van-field>
          </van-cell-group>
        </van-row>
      </div>
    </van-dialog>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
  import navBar from "../components/navBar"
  import pdf from "vue-pdf"
  import Bus from "../../../providers/eventBus"
  import Clipboard from 'clipboard';
  export default {
    name: "signContract",
    components: {
      navBar,
      pdf
    },
    data() {
      return {
        value: 1,
        showPdf: false,
        contidractStyle: {
          'background-color': '#E3E3E3',
          height: '400px'
        },
        show: false,
        dialogShow: false,
        showDialog2: false,
        phone: "",
        msg: "",
        phontCorrect: 0,
        down: 60,
        downcounttime: 0,
        spacePop: false,
        getVerifyNum: 0,
        stopGet: "",
        flag: 0,
        close_ClickOverlay: false,
        sealKey: "",
        pdfSrc: "",
        pdfStyle: {
          'transform-origin': 'left top'
        },
        contractMsg: '',
        real_id: '',
        divSign1: {},
        divSign2: {},
        divSign3: {},
        numPages: undefined,
        checkSign: false,
        img_file: '',
        img_name: '',
        isCompany: false,
        seal_url: '',
        isDisabled: false,
        lock: false,
        loading: false,
        ordersn: '',
        identity: '',
        entry: Number,
        type: '',
        member_id: '',
        copyContent: '',
        user_contract_type: Number
      }
    },
    computed: {
      percentValue() {
        return parseInt(parseFloat(this.value) * 100) + '%'
      },
    },
    mounted: function () {
      // this.handleCanvas();
      const navBarHeight = document.getElementsByClassName("relief-nav-bar")[0]
        .offsetHeight;
      const signBoxHeight = document.getElementById("signBox").offsetHeight;
      const warpperHeight = document.getElementById("signContract_warpper").offsetHeight;
      document.getElementById("contidract").style.height = warpperHeight - signBoxHeight - navBarHeight + "px";
      this.contidractStyle.height = document.body.clientHeight - (88 + 28 + 86) + 'px'
    },
    created() {
      Bus.$on('busSignature', this.handleBusSignature)
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.type = this.$route.query.type
      this.entry = this.$route.query.entry
      this.member_id = this.$route.query.memberId
      this.user_contract_type = this.$route.query.user_contract_type;
      // this.copyContent =
      //   `${process.env.VUE_APP_BASE_URL}/house/person/signContract?type=${this.type}&entry=3&memberId=${this.member_id}`
      this.handleInput();
      setTimeout(() => {
        this.onLoad()
      }, 200)
    },
    methods: {
      handleBusSignature(data) {
        this.img_file = data.img_file
        this.img_name = data.img_name
        this.checkSign = true
      },
      stepperOnchange() {
        this.$nextTick(() => {
          // this.pdfStyle.width = this.percentValue
          this.pdfStyle.transform = `scale(${this.value})`
          // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
          this.$refs.pdfbox.style.display = 'none'
          // if (this.divSign1 instanceof HTMLElement) {
          //   // 本身需要缩小0.5，以0.5倍为基准
          //   this.divSign1.style.transform = `scale(${0.5 * this.value})`
          //   this.divSign1.style.bottom = `${80 * this.value}px`
          //   if (this.isCompany) {
          //     this.divSign1.style.left = `${(document.body.clientWidth - (60 + 180/2)) * this.value}px`
          //   } else {
          //     this.divSign1.style.left = `${60 * this.value}px`
          //   }
          // }
          this.isDisabled = true
          setTimeout(() => {
            // 刷新pdf整体容器，解决IOS放大缩小后的样式混乱BUG
            this.$refs.pdfbox.style.display = 'block'
          }, 10)
          setTimeout(() => {
            this.isDisabled = false
          }, 200)
        })
      },
      goBack() {
        this.params("", "", "goBack");
        this.$router.go(-1);
        // this.$router.push({
        //   path: '/debtRelief/wrDebtPersonHome',
        //   query: {
        //     token: localStorage.getItem('_token')
        //   }
        // })
      },
      onLoad() {
        // 签署
        let type
        if (this.type == 20) {
          type = [10, 20]
        } else {
          type = [this.type]
        }
        if (this.entry == 1) {
          this.$api.post('estate/member/user/contract/detail', {
            type
          }).then(res => {
            this.contractMsg = res.contract_role_info
            this.real_id = res.user_info.member_id
            if (res.base_file_url) {
              this.pdfSrc = location.protocol + '//' + res.base_file_url.split('//')[1];
            }
            if (this.pdfSrc) {
              this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
              this.pdfSrc.promise.then((pdf) => {
                this.numPages = pdf.numPages;
              });
            }
          })
        }
        // 查看
        if (this.entry == 2) {
          this.$api.post('estate/member/user/contract/sign/detail', {
            type,
            user_contract_type: this.user_contract_type
          }).then(res => {
            if (res.contractInfo) {
              this.pdfSrc = location.protocol + '//' + res.contractInfo.split('//')[1];
              this.copyContent = res.contractInfo;
            }
            if (this.pdfSrc) {
              this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
              this.pdfSrc.promise.then((pdf) => {
                this.numPages = pdf.numPages;
              });
            }
          })
        }
        // 分享
        if (this.entry == 3) {
          this.$api.post('estate/index/user/contract/sign/detail', {
            type,
            member_id: this.member_id,
            user_contract_type: this.user_contract_type
          }).then(res => {
            if (res.contractInfo) {
              this.pdfSrc = location.protocol + '//' + res.contractInfo.split('//')[1]
            }
            if (this.pdfSrc) {
              this.pdfSrc = pdf.createLoadingTask(this.pdfSrc);
              this.pdfSrc.promise.then((pdf) => {
                this.numPages = pdf.numPages;
              });
            }
          })
        }
      },
      async pdfLoaded(i) {
        if (this.numPages !== i) {
          return
        }
        if (this.entry == 1) {
          let realName = this.contractMsg.filter(item => {
            if (item.member_id == this.real_id) {
              return item.name
            }
          })
          const flag = true
          const dom = this.$refs.pdfs[i - 1].$el
          const dv1 = document.createElement('div')
          const dv2 = document.createElement('div')
          const dv3 = document.createElement('img')
          const span1 = document.createElement('span')
          const span2 = document.createElement('span')
          const span3 = document.createElement('span')
          this.divSign1 = dv1
          this.divSign2 = dv2
          this.divSign3 = dv3
          dom.appendChild(dv1)
          dv1.appendChild(dv2)
          dv1.appendChild(dv3)

          // style
          dv1.style.position = 'absolute'

          dv1.style['transform-origin'] = 'left bottom'
          dv1.style.bottom = '250px'
          dv1.style.left = '250px'
          dv1.style.width = '180px'
          dv2.style.height = '30px'
          dv3.style.height = '90px'
          // TODO
          // dv3.src = 'https://ng.ant.design/assets/img/logo.svg'
          if (this.checkSign == true) {
            dv3.src = this.img_file
          }
          span3.innerText = '签名'
          dv1.addEventListener('click', this.goSign)
          // scale 基准值0.5
          dv1.style.transform = 'scale(0.5)'

          dv2.style.width = '100%'
          if (flag) {
            dv2.style.border = '1px dashed #fc740c'
            dv2.style['border-bottom'] = 'none'
            dv2.style['font-size'] = '16px'
            span1.innerText = '请'
            span2.innerText = realName[0] ? realName[0].name : ''
            span2.style.color = '#fc740c'
            // span3.innerText = '签名'
            dv2.appendChild(span1)
            dv2.appendChild(span2)
            dv2.appendChild(span3)
          }

          dv3.style.width = '100%'
          if (flag) {
            dv3.style.border = '1px dashed #fc740c'
          }
          setTimeout(() => {
            this.setScroll()
          }, 500)
        }
      },
      setScroll() {
        const parentDom = this.$refs.contidract
        const parentDomHeight = parentDom.getBoundingClientRect().height
        let sumHeight = 0
        for (let i = 0; i < parentDom.children.length; i++) {
          sumHeight += parentDom.children[i].getBoundingClientRect().height
        }

        const shouldScrollHeight = sumHeight - parentDomHeight
        parentDom.scrollTop = shouldScrollHeight
      },
      goSign() {
        this.$router.push({
          path: '/house/person/signature',
          query: {
            token: this.$route.query.token
          },
        })
      },
      handleSignClick() {
        this.show = true;
      },
      handleInput() {
        if (/Android/gi.test(navigator.userAgent)) {
          window.addEventListener("resize", function () {
            window.setTimeout(function () {
              document.activeElement.scrollIntoView(false);
            }, 1);
          });
        }
      },
      async submit() {
        this.loading = true
        if (this.lock) {
          this.loading = false
          return
        }
        let type
        if (this.type == 20) {
          type = [10, 20]
        } else {
          type = [this.type]
        }
        this.lock = true
        try {
          let param = {
            type,
            phone: this.phone,
            code: this.msg,
            seal: this.img_name,
          }
          await this.$api.post('estate/member/user/contract/sign/contract', param).then(res => {
            this.$router.push('/house/person/signed')
          })
          // this.$toast("签名成功")
        } catch (err) {
          if (err.code && err.code.length) {
            this.$toast(err.code[0])
          } else {
            this.$toast(err.message)
          }
          this.lock = false
          this.loading = false
        }
      },
      phoneConfirm() {
        this.verigyPhone();
        if (this.phontCorrect !== 1) {
          this.$toast("请填写正确的手机号");
          return
        }
        if (this.msg == "") {
          this.$toast("验证码为空");
          return
        }
        // this.dialogShow = false
        this.submit();
      },
      //手机号验证
      verigyPhone() {
        if (this.phone == "") {
          this.$toast("请输入手机号");
        } else {
          if (/^1\d{10}$/.test(this.phone)) {
            this.phontCorrect = 1;
          } else {
            this.$toast("手机号格式错误");
            return false;
          }
        }
      },
      //短信验证
      getvarify() {
        if (this.getVerifyNum < 5) {
          this.getVerifyNum++;
          this.verigyPhone();
          const _this = this;
          if (this.phontCorrect == 1) {
            this.$api
              .post("/pushmsg/index/sms/send-code", {
                mobile: this.phone,
                type: 8,
              })
              .then((res) => {
                _this.down = 60;
                const timer = setInterval(function () {
                  _this.down--;
                  _this.downcounttime = 1;
                  if (_this.down <= 0) {
                    clearInterval(timer);
                    _this.downcounttime = 0;
                  }
                }, 1000);
                _this.$toast("验证码已发送，请注意查收");
              })
              .catch((err) => {
                console.log(err)
                this.$toast(err.message)
              });
          }
        } else {
          var current = Math.floor(new Date().getTime() / 1000);
          var tip = "";
          if (this.getVerifyNum == 5) {
            this.getVerifyNum++;
            this.stopGet = current + 60 * 15;
            //        this.$toast('获取验证码次数已超过5次，请过15分钟之后再试。')
          }
          var ts = this.stopGet - current;
          var mm = Math.floor(ts / 60);
          var ss = ts - mm * 60;
          if (mm && ss) {
            tip =
              "获取验证码次数已超过5次，请过" + mm + "分钟" + ss + "秒之后再试。";
          } else if (mm && !ss) {
            tip = "获取验证码次数已超过5次，请过" + mm + "分钟之后再试。";
          } else if (!mm && ss) {
            tip = "获取验证码次数已超过5次，请过" + ss + "秒之后再试。";
          }

          this.$toast(tip);
        }
      },
      copyLink() {
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$toast("复制成功");
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          this.$toast("复制失败");
          // 释放内存
          clipboard.destroy();
        });
      }
    }
  }
</script>

<style lang="less">
  #signContract_warpper {
    // position: fixed;
    // top: 0;
    // left: 0;
    // height: 100%;
    // width: 100%;
    // box-sizing: border-box;
    // overflow-y: auto;
    // &::-webkit-scrollbar {
    //   display: none;
    // }
    // overflow: hidden;
    padding-top: 88px;
    box-sizing: border-box;
    background-color: #fff;
    min-height: 100%;
    font-size: 16px;

    #contidract {
      &::-webkit-scrollbar {
        display: none;
      }

      overflow: scroll;
      position: relative;
    }

    .stepper-warpper {
      height: 28px;
      position: relative;
      background-color: #fff;

      .van-stepper {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }

      .percent {
        position: absolute;
        height: 28px;
        line-height: 28px;
        width: 40px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        background-color: #f2f3f5;
        font-size: 13px;
      }
    }

    #signBox {
      padding-top: 12px;
      background-color: #f8f8f8;
      box-shadow: 0px -4px 16px 0px rgba(198, 198, 198, 0.5);

      // height: 200px;
      #signNameCanvasBox {
        width: 100%;
        height: 98px;
        // margin-top: 6px;
        background: #fff;

        .signature {
          color: #f9591b;
          font-weight: 600;
          font-size: 20px;
          line-height: 98px;
          text-align: center;
        }

        .canvas {
          display: none;
        }
      }

      .complete {
        margin: 0 12px;
        padding-bottom: 24px;

        .operation_btn {
          background-color: #fc740c;
          color: #fff;
          border: none;
          width: 100%;
          margin: 0 auto;
          height: 50px;
          font-size: 17px;
          display: block;
          border-radius: 30px;
          line-height: 50px;
          font-weight: 600;
        }

        .copylink {
          // background-color: aquamarine;
          width: 100%;
          height: 50px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          // box-shadow: 0px -4px 16px 0px rgba(198, 198, 198, 0.5);

          .copylinkImg {
            width: 24px;
            margin-right: 14px;
          }

          .copylinkTxt {
            font-size: 16px;
            color: #333333;
          }
        }
      }
    }

    .verification_code {
      width: 98px;
      border-radius: 6px;
      color: #ffffff;
      height: 38px;
      font-size: 16px;
      background-color: #fc740c;
      border: 1px solid #ebedf0;
    }

    .downcount {
      width: 100px;
      border-radius: 6px;
      color: #cccccc;
      height: 40px;
      font-size: 16px;
      background-color: #f5f6f7;
      border: 1px solid #ebedf0;
    }

    .codeBox {
      padding: 10px 16px 0;
      // border-bottom: 1px solid #f4f5f7;
    }

    .van-field__control {
      font-size: 16px;
    }

    .van-dialog__header {
      padding: 20px 0 24px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
    }

    .van-dialog {
      width: 274px;
      border-radius: 3px;

      .van-dialog__content {
        .van-dialog__message {
          font-size: 16px;
          padding: 30px 49px;
        }
      }
    }

    .loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      // background: rgba(0, 0, 0, 0.3);

      img {
        width: 35%;
        margin-top: 65%;
      }
    }

  }
</style>